import { Auth0Provider } from '@auth0/auth0-react';

export default function Auth0ProviderWithConfig({ children }) {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const redirectUri = import.meta.env.VITE_AUTH0_CALLBACK_URL || window.location.origin;

  if (!domain || !clientId) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="bg-red-900/30 border border-red-500 rounded-lg p-6 max-w-md">
          <h2 className="text-xl font-bold text-red-400 mb-2">Configuration Error</h2>
          <p className="text-gray-300">
            Auth0 configuration is missing. Please check your .env file.
          </p>
        </div>
      </div>
    );
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        // Request an access token for our dedicated custom API (NOT the Auth0
        // Management API). Configurable via VITE_AUTH0_AUDIENCE so the value can be
        // flipped per environment without a code change.
        audience: import.meta.env.VITE_AUTH0_AUDIENCE || 'https://tmpc-nextgen-api',
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      // If a refresh token is unexpectedly absent (stale pre-migration cache),
      // fall back to iframe silent auth against the live Auth0 SSO session
      // before failing — best-effort rescue that avoids a visible re-login.
      useRefreshTokensFallback={true}
      // After the session-expired re-login (useApi bounces with a returnTo),
      // land the user back on the page they were working in.
      onRedirectCallback={(appState) => {
        window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
      }}
    >
      {children}
    </Auth0Provider>
  );
}
